<!-- start page title -->
<!-- <app-pagetitle title="Dashboard" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->
<!-- end page title -->
<div class="container" *ngIf="showValidation">
  <div class="alert alert-danger" role="alert">
    Debes validar tu correo para seguir usando tu cuenta.
    <a href="javascript:void(0)" (click)="setValidation()" class="alert-link"
      >Click aquí para validar</a
    >
  </div>
</div>
<!-- <div class="container" *ngIf="!showConsentimiento">
    <div class="alert alert-danger" role="alert">
        Aún no has llenado tu consentimiento informado!!. <a href="/consentimiento" class="alert-link">Click aquí para diligenciarlo</a>
    </div>
</div> -->

<app-form-solicitud> </app-form-solicitud>

<div id="misCitas">
  <!-- <app-proximas-citas> </app-proximas-citas> -->
  <app-proximas-citas
    [misPaquetesRef]="misPaquetesComponent"
  ></app-proximas-citas>
</div>
<!--
<div id="misPaquetes">
  <app-mis-paquetes></app-mis-paquetes>
</div>-->
<!--
<div id="listadoPaquetes">
  <app-listado-paquetes></app-listado-paquetes>
</div>-->
<div></div>
